<form [formGroup]="telephoneForm">
  <input readonly class="placeholder" [placeholder]="placeholder" tabindex="-1" />
  <span> + </span>
  <div class="countrycode-container">
    <input class="cc" type="text" maxlength="3" formControlName="countryCode" [class.disabled]="formControl.disabled" />
    <app-error-message
      *ngIf="telephoneForm?.controls?.['countryCode']?.errors && telephoneForm?.controls?.['countryCode']?.touched"
      [validationErrors]="telephoneForm.controls['countryCode'].errors"
    ></app-error-message>
  </div>
  <div class="input-with-errors-container">
    <input #phoneNumberInput type="text" maxlength="16" formControlName="phoneNumber" [class.disabled]="formControl.disabled" />
    <app-error-message
      *ngIf="telephoneForm?.controls?.['phoneNumber']?.errors && telephoneForm?.controls?.['phoneNumber']?.touched"
      [validationErrors]="telephoneForm.controls['phoneNumber'].errors"
    ></app-error-message>
  </div>
</form>
